import React, { FC, PropsWithChildren } from 'react'

import { useStyles } from './styles'

export const CardItem: FC<PropsWithChildren> = ({ children }) => {
    const styles = useStyles()

    return (
        <div className={styles.container}>
            { children }
        </div>
    )
}